import Vue from 'vue'
import axios from 'axios'
import {message} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router from '../router'
import store from '../store'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 10000 // 请求超时时间
})
const err = (error) => {
  if (error.response) {
    const data = error.response.data
    if (data.resp_msg && data.resp_msg !== '') {
      message.error(data.resp_msg)
    }
  } else {
    message.error('请求超时！')
  }
  return Promise.reject(error.response)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = 'bearer ' + token // 让每个请求携带自定义 token
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  const res = response.data
  if (res.resp_code !== undefined) {
    if (res.resp_code === 0) {
      if (res.resp_msg !== '') message.success(res.resp_msg)
      return res
    } else if (res.resp_code === 401 && res.resp_msg.indexOf('Invalid') !== -1 ) {
      // message.error('登录过期，请重新登录！')
      message.error(res.resp_msg)
      store.dispatch('Clear').then(() => {
        router.push({ path: '/home' })
      })
    } else if (res.resp_code !== 0) {
      if (res.resp_msg !== '') message.error(res.resp_msg)
    }
  } else {
     return response
  }
  return Promise.reject(response)
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
